<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    export let src = '';
    export let alt = '';
    export let editMode = false;
    
    const dispatch = createEventDispatcher();

    function handleDelete() {
        src = '';
        dispatch('delete');
    }
</script>

<style>
    .delete-button {
        position: absolute;
        top: 0;
        right: 0;
        background-color: red;
        color: white;
        cursor: pointer;
        border: none;
        padding: 5px;
        width: 25px;
        height: 25px; /* Corrected typo from 25x to 25px */
        text-align: center;
    }
</style>

<!--div class="image-container"-->
    {#if src === '' || src === null}
        <!--div class="no-image">No Image</div-->
    {:else}
        <img class="ui circular image" src={src} alt={alt}>
        {#if editMode}
            <button class="delete-button" on:click={handleDelete}>X</button>
        {/if}
    {/if}
<!--/div-->